var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004826"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624133",
    width: 52,
    height: 52,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 240",
    x1: 5,
    y1: 12.5,
    x2: 34,
    y2: 12.5,
    stroke: "#A0A2A4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 241",
    x1: 5,
    y1: 19.5,
    x2: 44,
    y2: 19.5,
    stroke: "#A0A2A4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 242",
    x1: 5,
    y1: 25.5,
    x2: 44,
    y2: 25.5,
    stroke: "#A0A2A4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 243",
    x1: 5,
    y1: 31.5,
    x2: 44,
    y2: 31.5,
    stroke: "#A0A2A4",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.1a791f67a575aca174b2c1ceff302f37.svg";
export { ForwardRef as ReactComponent };